// extracted by css-extract-rspack-plugin
export default {"root":"Ja5lEC"};